/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { CompleteEncounterRequestDisposition } from './CompleteEncounterRequestDisposition';
import {
    CompleteEncounterRequestDispositionFromJSON,
    CompleteEncounterRequestDispositionFromJSONTyped,
    CompleteEncounterRequestDispositionToJSON,
    CompleteEncounterRequestDispositionToJSONTyped,
} from './CompleteEncounterRequestDisposition';

/**
 * 
 * @export
 * @interface CompleteEncounterRequest
 */
export interface CompleteEncounterRequest {
    /**
     * 
     */
    actual_end_at: Date;
    /**
     * 
     */
    disposition: CompleteEncounterRequestDisposition;
    /**
     * 
     */
    comment?: string;
    /**
     * 409 if the episode changed since
     */
    expected_latest_history_id?: string;
}

/**
 * Check if a given object implements the CompleteEncounterRequest interface.
 */
export function instanceOfCompleteEncounterRequest(value: object): value is CompleteEncounterRequest {
    if (!('actual_end_at' in value) || value['actual_end_at'] === undefined) return false;
    if (!('disposition' in value) || value['disposition'] === undefined) return false;
    return true;
}

export function CompleteEncounterRequestFromJSON(json: any): CompleteEncounterRequest {
    return CompleteEncounterRequestFromJSONTyped(json, false);
}

export function CompleteEncounterRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompleteEncounterRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'actual_end_at': (json['actual_end_at'] == null ? json['actual_end_at'] : parseDateTime(json['actual_end_at'])),
        'disposition': CompleteEncounterRequestDispositionFromJSON(json['disposition']),
        'comment': json['comment'] == null ? undefined : json['comment'],
        'expected_latest_history_id': json['expected_latest_history_id'] == null ? undefined : json['expected_latest_history_id'],
    };
}

export function CompleteEncounterRequestToJSON(json: any): CompleteEncounterRequest {
    return CompleteEncounterRequestToJSONTyped(json, false);
}

export function CompleteEncounterRequestToJSONTyped(value?: CompleteEncounterRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'actual_end_at': value['actual_end_at'] == null ? value['actual_end_at'] : serializeDateTime(value['actual_end_at']),
        'disposition': CompleteEncounterRequestDispositionToJSON(value['disposition']),
        'comment': value['comment'],
        'expected_latest_history_id': value['expected_latest_history_id'],
    };
}

